import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null,
  isAuth: localStorage.getItem("authToken") ? true : false,
  authToken: localStorage.getItem("authToken")
    ? localStorage.getItem("authToken")
    : null,
};

// Rôle : Gestion de l'état d'authentification Keycloak
// setUser : Stocke les informations utilisateur Keycloak
// setAuthToken : Stocke le token d'authentification Keycloak
// logout : Nettoie l'état d'authentification

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    logout(state) {
      localStorage.clear();
      state.user = null;
      state.isAuth = false;
      state.authToken = null;
    },
    setUser(state, action) {
      state.user = action.payload;
      state.isAuth = true;
      localStorage.setItem("user", JSON.stringify(action.payload));
      localStorage.setItem("isAuth", true);
    },
    setAuthToken(state, action) {
      state.authToken = action.payload;
      localStorage.setItem("authToken", action.payload);
    },
  },
});

export const { logout, setUser, setAuthToken } = authSlice.actions;
export const authSelector = (state) => state.auth;

export default authSlice.reducer;
